import axios from '@/axios'

// grade units

export async function listGradeUnits (gradeId, parameters = '') {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/grades/' + gradeId + '/units' + parameters)
  return response.data.data
}

export async function newGradeUnit (gradeId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/grades/' + gradeId + '/units', data)
  return response.data.data
}

export async function getGradeUnit (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/units/' + id)
  return response.data.data
}

export async function updateGradeUnit (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/units/' + id, data)
  return response.data.data
}

export async function deleteGradeUnit (id) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/units/' + id)
  return response.data.data
}

export default {
  listGradeUnits,
  newGradeUnit,
  getGradeUnit,
  updateGradeUnit,
  deleteGradeUnit
}
